export enum LOCAL_STORAGE_KEY {
  IS_MAIL_VERIFICATION_ALREADY_SHOWN = 'isMailVerificationAlreadyShown',
  EMAIL_VERIFICATION_DATE = 'emailVerificationDate',
  PAYMENT_SUCCESS_ORDER_ID = 'paymentSuccessOrderId',
  TRIAL_STORAGE_KEY = 'trialModalExpiration',
  SOUND_ENABLED = 'soundEnabled'
}
